








import { Component, Vue } from 'vue-property-decorator';

@Component({})
export default class BotPausedBanner extends Vue {
	public resume() {
		this.$emit('resume');
	}
}
